import { createEntity, upsertEntity } from 'actions/entities'

export function sendEmail(attributes) {
  return function(dispatch) {
    dispatch(createEntity('emailCommunication', { id: "-1", attributes: attributes}))
    dispatch(upsertEntity('emailCommunication', "-1"))
  }
};
